import styles from "./Box.module.css";

import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

function Box({ icon, name, detail }) {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);
    
    return (
        <div className={styles.box} data-aos="fade-up">
            <div className={styles.icon}>
                {icon}
            </div>
            <div className={styles.text}>
                <div className={styles.title}>{name}</div>
                <div className={styles.description}>{detail}</div>
            </div>
        </div>
    )
}

export default Box;